import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarCheck, MessageCircle, Clock } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { waLink } from "@/lib/api";

const fade = (d) => ({ initial: { opacity: 0, y: 30 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.9, delay: d, ease: [0.2, 0.7, 0.2, 1] } });

export function Hero() {
  const { settings } = useSite();
  return (
    <section className="relative min-h-[100svh] ym-dark overflow-hidden grain" data-testid="hero-section">
      <img src="/images/hero.jpg" alt="Yeni Mercan sofrası" className="absolute inset-0 h-full w-full object-cover opacity-45 scale-105" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#140D0B] via-[#140D0B]/80 to-[#140D0B]/30" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#140D0B] to-transparent" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 pt-40 pb-24 lg:pt-48 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <motion.div {...fade(0.1)} className="inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/40 bg-[#140D0B]/50 backdrop-blur px-4 py-1.5" data-testid="hero-badge-247">
            <span className="relative flex h-2 w-2"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#D4AF37] opacity-75" /><span className="relative inline-flex h-2 w-2 rounded-full bg-[#D4AF37]" /></span>
            <span className="eyebrow !text-[10px] !tracking-[0.28em]">Buca · İzmir · 7/24 Açık</span>
          </motion.div>
          <motion.h1 {...fade(0.25)} className="mt-8 font-serif-ym text-5xl sm:text-6xl lg:text-7xl font-semibold leading-[0.98] tracking-tight" data-testid="hero-title">
            {settings.hero_title || "Annemizin tenceresi, ustamızın ateşi."}
          </motion.h1>
          <motion.p {...fade(0.4)} className="mt-7 max-w-xl text-base sm:text-lg text-[#CBBBAE] leading-relaxed" data-testid="hero-subtitle">
            {settings.hero_subtitle}
          </motion.p>
          <motion.div {...fade(0.55)} className="mt-10 flex flex-wrap gap-3">
            <Link to="/menu" className="btn-gold" data-testid="hero-view-menu-btn">Menüyü İncele <ArrowRight size={16} /></Link>
            <a href="#rezervasyon" className="btn-ghost-gold" data-testid="hero-reserve-btn"><CalendarCheck size={16} /> Masa Ayırt</a>
            <a href={waLink(settings.whatsapp, "Merhaba, sipariş/rezervasyon için yazıyorum.")} target="_blank" rel="noopener noreferrer" className="btn-ghost-gold" data-testid="hero-whatsapp-btn">
              <MessageCircle size={16} /> WhatsApp
            </a>
          </motion.div>
          <motion.div {...fade(0.7)} className="mt-14 flex flex-wrap gap-x-10 gap-y-4 text-sm text-[#CBBBAE]">
            {["Kahvaltı", "Ev Yemekleri", "Çorba", "Kokoreç", "Kafe"].map((t) => (
              <span key={t} className="flex items-center gap-2"><span className="h-1 w-1 rotate-45 bg-[#D4AF37]" />{t}</span>
            ))}
          </motion.div>
        </div>
        <motion.div initial={{ opacity: 0, scale: 0.85 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1.2, delay: 0.3 }} className="lg:col-span-5 hidden lg:flex justify-center">
          <div className="relative float-slow">
            <div className="absolute -inset-10 rounded-full bg-[#D4AF37]/20 blur-3xl" />
            <img src="/brand/logo.png" alt="Yeni Mercan amblemi" className="relative w-[380px] h-[380px] rounded-full drop-shadow-[0_30px_60px_rgba(0,0,0,.7)]" data-testid="hero-logo" />
            <div className="absolute -bottom-4 -left-6 rounded-md border border-[#D4AF37]/30 bg-[#1F1411]/90 backdrop-blur-xl px-5 py-4 flex items-center gap-3">
              <Clock className="text-[#D4AF37]" size={22} />
              <div>
                <p className="font-display text-sm tracking-[0.12em]">Lezzet 7/24</p>
                <p className="text-xs text-[#CBBBAE]">Gece gündüz sıcak servis</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
